import {getRefreshToken} from './useToken'

export function createAuthFetch(accessToken, setTokens) {
    console.log("createAuthFetch() initialized with token:", accessToken);
    return async function authFetch(url, options = {}) {
        const opts = {
            ...options,
            headers: {
                ...(options.headers || {}),
                "Content-Type": "application/json",
                Authorization: accessToken ? `Bearer ${accessToken}` : "",
            },
            credentials: "include", // <--- important! send cookies (refresh token)
        };

        console.log("Calling authFetch:", url, opts);

        let response = await fetch(url, opts);

        if (response.status === 401) {
            console.log("Access token expired, refreshing...");
            // try refresh
            const refreshRes = await fetch(
                `${process.env.REACT_APP_API_URL}/user/refresh`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({refreshToken: getRefreshToken()}),
                }
            );

            if (refreshRes.ok) {
                console.log("New access token obtained...");
                const {access_token, refresh_token} = await refreshRes.json();

                setTokens({access_token, refresh_token});

                console.log("New access token set...");

                // retry with new token
                const retryOpts = {
                    ...options,
                    headers: {
                        ...(options.headers || {}),
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`,
                    },
                    credentials: "include",
                };
                console.log("Re-trying with new access token...");
                response = await fetch(url, retryOpts);
            } else {
                console.log("Refresh not successful!");
                // refresh failed → log out
                // localStorage.removeItem("access_token");
                localStorage.removeItem("access_token");
                localStorage.removeItem("refresh_token");
                window.location.href = "/";
                throw new Error("Refresh failed");
            }
        }
        console.log("Refresh seems to have worked!");
        return response;
    };
}
